import { render, staticRenderFns } from "./suporte-contratos.vue?vue&type=template&id=ddcc7340&scoped=true"
import script from "./suporte-contratos.vue?vue&type=script&lang=ts"
export * from "./suporte-contratos.vue?vue&type=script&lang=ts"
import style0 from "./suporte-contratos.vue?vue&type=style&index=0&id=ddcc7340&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcc7340",
  null
  
)

export default component.exports